import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { ArLoadingModalComponent } from '@shared/modals/ar-loading-modal/ar-loading-modal.component';
import { QuizModalComponent } from '@shared/modals/quiz-modal/quiz-modal.component';
import { FeedbackFormComponent } from '@shared/feedback-form/feedback-form.component';
import { SelectBackgroundModalComponent } from '@shared/modals/select-background-modal/select-background-modal.component';
import { RotateDeviceModalComponent } from '@shared/modals/rotate-device-modal/rotate-device-modal.component';
import { SaveWorkEmailModalComponent } from '@shared/modals/save-work-email-modal/save-work-email-modal.component';
import { DisabledLinkModalComponent } from '@shared/modals/disabled-link-modal/disabled-link-modal.component';
import { ArNoBlindsModalComponent } from '@shared/modals/ar-no-blinds-modal/ar-no-blinds-modal.component';
import { AnotherDeviceModalComponent } from '@shared/modals/another-device-modal/another-device-modal.component';
import { LinkUnavailableModalComponent } from '@shared/modals/link-unavailable-modal/link-unavailable-modal.component';
import { ConfirmModalComponent } from '@shared/modals/confirm-modal/confirm-modal.component';
import { BlindListModalComponent } from '@shared/modals/blind-list-modal/blind-list-modal.component';
import { DetectionErrorModalComponent } from '@shared/modals/detection-error-modal/detection-error-modal.component';

type DialogConfig = {
	[propName: string]: MatDialogConfig;
};

export function getModalsConfig(): DialogConfig {
	return {
		[ArLoadingModalComponent.ID]: {
			width: '100vw',
			maxWidth: '100vw',
			height: '100vh',
			disableClose: true,
			closeOnNavigation: false,
		},
		[QuizModalComponent.ID]: {
			id: QuizModalComponent.ID,
			panelClass: ['mc-modal__quiz-pane', 'mc-modal__quiz-offset'],
			hasBackdrop: false,
			backdropClass: null,
			disableClose: false,
			maxWidth: '100vw',
			autoFocus: false,
		},
		[FeedbackFormComponent.ID]: {
			width: '100%',
			maxWidth: '590px',
			height: 'auto',
			minHeight: '200px',
			panelClass: 'mc-modal__internal',
		},
		[SelectBackgroundModalComponent.ID]: {
			id: SelectBackgroundModalComponent.ID,
			width: 'max-content',
			maxWidth: '940px',
			height: 'auto',
			minHeight: '150px',
			panelClass: 'mc-modal__internal',
		},
		[RotateDeviceModalComponent.ID]: {
			id: RotateDeviceModalComponent.ID,
			width: 'max-content',
			maxWidth: '590px',
			height: 'auto',
			disableClose: true,
			panelClass: ['mc-modal__hide-behind', 'mc-modal__rotate-device'],
			backdropClass: 'mc-modal__hide-behind-backdrop',
		},
		[SaveWorkEmailModalComponent.ID]: {
			width: '100%',
			maxWidth: '690px',
			height: 'auto',
			minHeight: '200px',
			panelClass: 'mc-modal__internal',
		},
		[DisabledLinkModalComponent.ID]: {
			width: '100vw',
			maxWidth: '100vw',
			height: '100vh',
			panelClass: ['mc-modal__internal', 'mc-modal__full-screen'],
		},
		[ArNoBlindsModalComponent.ID]: {
			width: '100%',
			maxWidth: '600px',
			panelClass: 'mc-modal__internal',
		},
		[AnotherDeviceModalComponent.ID]: {
			id: AnotherDeviceModalComponent.ID,
			width: '100%',
			maxWidth: '700px',
			height: 'auto',
			minHeight: '200px',
			panelClass: 'mc-modal__internal',
		},
		[LinkUnavailableModalComponent.ID]: {
			width: '100%',
			maxWidth: '700px',
			height: 'auto',
			minHeight: '200px',
			panelClass: 'mc-modal__internal',
			disableClose: true,
			closeOnNavigation: false,
		},
		[ConfirmModalComponent.ID]: {
			width: '100%',
			maxWidth: '720px',
			height: 'auto',
			minHeight: '200px',
			panelClass: 'mc-modal__internal',
		},
		[BlindListModalComponent.ID]: {
			width: '100%',
			maxWidth: '620px',
			height: 'auto',
			minHeight: '180px',
			panelClass: 'mc-modal__internal',
		},
		[DetectionErrorModalComponent.ID]: {
			width: '100%',
			maxWidth: '690px',
			height: 'auto',
			panelClass: 'mc-modal__internal',
		},
	};
}
